import React from "react";

import Editor from './ASliderEditor'
import EditorWrapper from '../../EditorWrapper'

import EmptyArticle from "../../common/EmptyArticle";
import ImageSlider from "../../common/ImageSlider"

const AImageSlider = props => {
    let article = EmptyArticle();
    const { settings } = props;
    const url1 = (settings['background_image1'] ? settings['background_image1'] : '');
    const url2 = (settings['background_image2'] ? settings['background_image2'] : '');
    article.picture.img1 = window.MEDIA_DOMAIN + '/' + url1.replace('.', ',870,0,0,0.');
    article.picture.img2 = window.MEDIA_DOMAIN + '/' + url2.replace('.', ',870,0,0,0.');

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <ImageSlider url1={article.picture.img1} url2={article.picture.img2} />
        </div>
    );
};

export default AImageSlider;
